module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAAXNSR0IArs4c6QAAAHNJREFUKBW9kcEJwCAMRZM0XcOuWhyuglepC4hbWK3JvUI9+EEN+F9+UGxdMCGaYBRZD7K1Jxhz/Jo45wycUgLmHYion9uwQSkPyFsKI0Vz7mox3lIOFUJo3nv1oOy1VkBEXaPIbtVEmU7Bkfnrbv13TCe+lYtafA+PjW4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/centro-y-lateral.png
// module id = 495
// module chunks = 0